import Axios from "axios";
import { L } from './i18n';
import auth from "./auth";

export const endpointRedirect = "http://api.chordscore.com";
// export const endpointRedirect = "http://127.0.0.1:8000";

export const endpoint = "https://api.chordscore.com/api";
// export const endpoint = "https://api-demo.chordscore.com/api";
// export const endpoint = "http://localhost:8000/api";

// export const endpointRedirect = "http://api-dev.chordscore.com";
// export const endpoint = "https://api-demo.chordscore.com/api";
// export const endpoint = "https://api-dev.chordscore.com/api";

export const api = Axios.create({
    baseURL: endpoint,
    headers: {
        Authorization: `Bearer ${auth.getToken()}`,
    },
});

let refreshing: Promise<boolean> | null = null;

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        // 인터넷이 끊기거나 요청이 취소되면 response 가 없다 → 그대로 실패로 넘김 (예전엔 여기서 'reading status' 오류)
        if (!error.response) return Promise.reject(error);

        if (error.response.status === 401 && originalRequest.url === `${endpoint}/refresh/token`) {
            window.location.href = "/auth/error";
            return Promise.reject(error);
        }

        // if (localStorage.getItem("retry")) {
        //   localStorage.removeItem("retry");
        //   window.location.href = "/auth/error";
        //   return null;
        // }

        if (error.response.status === 401) {
            localStorage.setItem("retry", "true");
            // 다른 탭·다른 요청이 이미 토큰을 새로 받았으면 그 토큰으로 다시 불러오기만 (갱신 토큰은 한 번 쓰면 무효라 또 갱신하면 실패 → 로그아웃됨)
            const sentToken = String((originalRequest.headers && originalRequest.headers["Authorization"]) || "").replace(/^Bearer\s+/i, "");
            const nowToken = auth.getToken();
            if (nowToken && sentToken && nowToken !== sentToken) {
                return window.location.reload();
            }
            // 401 이 여러 개 한꺼번에 와도 갱신은 한 번만
            if (!refreshing) {
                refreshing = api
                    .post("/refresh/token", {
                        refresh_token: auth.getRefreshToken(),
                    })
                    .then((res) => {
                        if (res.status === 200 && res.data.success) {
                            auth.setToken(res.data.data.access_token);
                            auth.setRefreshToken(res.data.data.refresh_token);
                            api.defaults.headers["Authorization"] =
                                res.data.data.access_token;
                            return true;
                        }
                        return false;
                    })
                    .catch((err) => {
                        console.log(err);
                        return false;
                    });
            }
            return refreshing.then((ok) => {
                if (ok) {
                    window.location.reload();
                } else {
                    // 갱신이 안 되는 로그인은 지운다. 예전엔 남아 있어서 화면을 옮길 때마다 갱신 실패를 되풀이했다
                    // (10/17 한 기기가 2분에 14번, 새벽 점검 ALERT 갱신 실패 37/40) (2026-10-18)
                    ["token", "refreshToken", "rememberMe"].forEach((k) => localStorage.removeItem(k));
                    window.location.href = "/auth/error";
                }
                // 화면을 다시 여는 중이므로 부른 쪽은 기다리게만 둔다. 예전엔 null 을 돌려줘서
                // 'const { data } = await api.get(...)' 마다 오류가 났다 — 화면 오류 1위(10/10~12 21번, 20대) (2026-10-12)
                return new Promise(() => {});
            });
        }

        if ((!localStorage.getItem("rememberMe") || localStorage.getItem("rememberMe") === "false") && error.response.status === 401) {
            window.location.href = "/auth/error";
            return null;
        }

        if(error.response.status === 500) {
            // 영어 'Error 500:' 글자만 뜨던 것을 쉬운 말로 (2026-10-19 품질 점검)
            alert(L('잠시 문제가 생겼어요. 조금 뒤에 다시 해 주세요.', 'Something went wrong. Please try again in a moment.'))
            console.log(error);
        }

        if(error.response.status === 404) {
            alert(L('찾는 내용이 없어요. 화면을 새로 고쳐 다시 해 주세요.', 'Not found. Please refresh and try again.'))
            console.log(error);
        }

        return Promise.reject(error);
    }
);
